module.exports = __webpack_public_path__ + "media/images/client_logos/logo_danone_200-ad5d6ef4e4d98da5c55cf687e6f281cd.png";